import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const landingPageContainerIsPhoneCss = "lgzfgve";
const landingPageContainerCss = "l1htmoc2";
export const LandingPageContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(landingPageContainerCss, {
    [landingPageContainerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const landingImageIsPhoneCss = "lus36k1";
const landingImageCss = "l1s16jj1";
export const LandingImage = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'img';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(landingImageCss, {
    [landingImageIsPhoneCss]: isPhone
  }, props.className)} />;
});
const copyWrapperIsPhoneCss = "cnisgap";
const copyWrapperCss = "c1sksu5h";
export const CopyWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(copyWrapperCss, {
    [copyWrapperIsPhoneCss]: isPhone
  }, props.className)} />;
});
const reengagementCopyWrapperCss = "r1mjv8qk";
const reengagementDeleteFooterCss = "r14vmp31";
const reengagementIllustrationColumnCss = "rdier3g";
const reengagementLandingContainerCss = "rkx9q51";
export const ReengagementDeleteFooter = forwardRef((props, ref) => <div ref={ref} {...props} className={classNames(reengagementDeleteFooterCss, props.className)} />);
export const ReengagementIllustrationColumn = forwardRef((props, ref) => <div ref={ref} {...props} className={classNames(reengagementIllustrationColumnCss, props.className)} />);
const reengagementModalPaddingCss = "r9jxdl5";
const reengagementStandalonePaddingCss = "r7n1el1";
export { reengagementModalPaddingCss, reengagementStandalonePaddingCss };
export const ReengagementCopyWrapper = forwardRef((props, ref) => <CopyWrapper ref={ref} {...props} className={classNames(reengagementCopyWrapperCss, props.className)} />);
export const ReengagementLandingPageContainer = forwardRef((props, ref) => <LandingPageContainer ref={ref} {...props} className={classNames(reengagementLandingContainerCss, props.className)} />);
const buttonContainerCss = "b1ogyoeb";
export const ButtonContainer = forwardRef((props, ref) => <div ref={ref} {...props} className={classNames(buttonContainerCss, props.className)} />);

require("./styles.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");